import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import config from '../../config'

export const initialize = () => {
  if (config.sentry.clientKey) {
    Sentry.init({
      release: '1.2.9',
      dsn: config.sentry.clientKey,
      integrations: [
        new Integrations.BrowserTracing(),
        new Sentry.Integrations.GlobalHandlers({
          onerror: true,
          onunhandledrejection: false
        })
      ],
      tracesSampleRate: 1.0,
      environment: process.env.NODE_ENV,
      ignoreErrors: [
        'undefined of undefined',
        'rdlParser',
        'InvalidCharacterError',
        '422',
        '401',
        'BoldBI',
        'style',
        'querySelector',
        'rdlJsonObj',
        'ejScroller',
        'getBoundingClientRect'
      ]
    })
  }
}

export const captureException = (error, errorInfo) => {
  if (config.sentry.clientKey) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo)
      return Sentry.captureException(error)
    })
  }
}

export default Sentry
